import React from 'react';
import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <>
      <Helmet>
        {/* SEO Básico */}
        <title>Lazer Zone Arena | Laser Tag in Cornwall</title>
        <meta
          name="description"
          content="Discover Lazer Zone Arena’s story and mission as Cornwall’s premier laser tag destination. Jungle-themed arenas, cutting-edge Zone tech, and heart-pounding adventures." 
        />
        <link rel="canonical" href="https://lazerzonearena.ca/about" />

        {/* Open Graph */}
        <meta property="og:type"        content="website" />
        <meta property="og:url"         content="https://lazerzonearena.ca/about" />
        <meta property="og:title"       content="Lazer Zone Arena | Laser Tag in Cornwall" />
        <meta
          property="og:description"
          content="Discover Lazer Zone Arena’s story and mission as Cornwall’s premier laser tag destination."
        />
        <meta property="og:image"       content="https://lazerzonearena.ca/logo512.png" />

        {/* Twitter Card */}
        <meta name="twitter:card"        content="summary_large_image" />
        <meta name="twitter:title"       content="Lazer Zone Arena | Laser Tag in Cornwall" />
        <meta
          name="twitter:description"
          content="Discover Lazer Zone Arena’s story and mission as Cornwall’s premier laser tag destination."
        />
        <meta name="twitter:image"       content="https://lazerzonearena.ca/logo512.png" />

        {/* JSON-LD Schema */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "AboutPage",
              "url": "https://lazerzonearena.ca/about",
              "mainEntity": {
                "@type": "Organization",
                "name": "Lazer Zone Arena",
                "url": "https://lazerzonearena.ca",
                "logo": "https://lazerzonearena.ca/logo512.png",
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "(613) 703-0489",
                  "contactType": "customer service",
                  "areaServed": "CA",
                  "availableLanguage": "en"
                },
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "917 Second St W",
                  "addressLocality": "Cornwall",
                  "addressRegion": "ON",
                  "postalCode": "K6J 1H8",
                  "addressCountry": "CA"
                }
              }
            }
          `}
        </script>
      </Helmet>

      {/* CONTENIDO VISIBLE */}
      <section
        style={{
          background: 'linear-gradient(180deg, #1F2937 0%, #141318 100%)',
          padding: 'clamp(3rem, 8vw, 5rem) 0',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Subtle decorative element (laser streak) */}
        <div
          style={{
            position: 'absolute',
            top: '10%',
            left: '-10%',
            width: '120%',
            height: '2px',
            background: 'linear-gradient(90deg, transparent, #FFD404 50%, transparent)',
            opacity: '0.3',
            transform: 'rotate(-45deg)',
          }}
        ></div>

        <div className="container">
          <div
            style={{
              backgroundColor: 'rgba(20, 19, 24, 0.85)',
              border: '1px solid #566D87',
              borderRadius: '12px',
              padding: 'clamp(1.5rem, 5vw, 2.5rem)',
              boxShadow: '0 0 20px rgba(86, 109, 135, 0.3)',
              maxWidth: '90%',
              margin: '0 auto',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 0 30px rgba(86, 109, 135, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 0 20px rgba(86, 109, 135, 0.3)';
            }}
          >
            <h1
              style={{
                fontFamily: "'Audiowide', sans-serif",
                color: '#566D87',
                fontSize: 'clamp(1.8rem, 6vw, 2.5rem)',
                textShadow: '0 0 10px rgba(86, 109, 135, 0.7)',
                marginBottom: '1.5rem',
                animation: 'fadeInUp 1s ease-out',
                textAlign: 'center',
              }}
            >
              Ignite Your Battle at Lazer Zone Arena
            </h1>
            <p
              style={{
                fontFamily: "'Inter', sans-serif",
                color: '#E9EAE8',
                fontSize: 'clamp(0.9rem, 3vw, 1.1rem)',
                lineHeight: '1.6',
                marginBottom: '1rem',
                textAlign: 'center',
              }}
            >
              Welcome to <span style={{ color: '#566D87', fontWeight: '500' }}>Lazer Zone Arena</span>, Canada’s premier destination for electrifying laser tag! Located in the heart of Cornwall, our 8,000-square-foot, jungle-themed arena plunges you into a glowing battlefield powered by cutting-edge Zone technology.
            </p>
            <p
              style={{
                fontFamily: "'Inter', sans-serif",
                color: '#E9EAE8',
                fontSize: 'clamp(0.9rem, 3vw, 1.1rem)',
                lineHeight: '1.6',
                textAlign: 'center',
              }}
            >
              From epic birthday battles to corporate team-building, our multi-level arena and diverse game modes welcome players of all ages. Strategize, tag, and conquer in an immersive experience that makes Lazer Zone Arena the ultimate laser tag hotspot in Cornwall.
            </p>
          </div>
        </div>

        {/* Inline CSS for animation */}
        <style>
          {`
            @keyframes fadeInUp {
              from {
                opacity: 0;
                transform: translateY(20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
        </style>
      </section>
    </>
  );
};

export default About;
